



























































































































import Vue from "vue";
import { mapGetters, mapState } from "vuex";
import Token from "@/components/Token.vue";
import ColorsGrid from "@/components/ColorsGrid.vue";

export default Vue.extend({
  name: "TokenPage",
  components: { Token, ColorsGrid },
  computed: {
    id(): string {
      return this.$route.params.id.toString();
    },
    palette() {
      return {
        color: this.data.tokenData.color,
        contrast: this.data.tokenData.contrast,
        shades: this.data.tokenData.shades,
        scheme: this.data.tokenData.scheme,
      };
    },
    ownerOf(): boolean {
      return this.currentAccount === (this as any).owner;
    },
    changedSettings() {
      return this.data.settings !== undefined &&
        (parseInt(this.data.settings.bkg) !== (this.settings.transparent ? 101 : this.settings.bkg) ||
        parseInt(this.data.settings.duration) !== this.settings.duration ||
        parseInt(this.data.settings.options) !== (this.settings.animate ? 1 : 0));
    },
    randomness(): string {
      return this.data.tokenData == undefined ? "" : BigInt(this.data.tokenData.randomness).toString(16);
    },
    ...mapState({
        animationTitles: 'animationTitles',
        schemeTitles: 'schemeTitles',
        openseaTokenURL: 'openseaTokenURL',
    }),
    ...mapGetters(["currentAccount"]),
  },
  mounted: async function() {
    await this.$store.dispatch("initialize");
    const t = this as any;
    await t.loadSettings();
    t.isLE = await t.checkLE();
    const leID = (BigInt(t.id) - t.max256 ).toString();
    t.formatedID = t.isLE ? leID : t.id;
    t.$store.state.contracts.tinyboxes.methods.ownerOf(t.id).call()
      .then( (owner: any) => {
        t.owner = owner;
        t.exists = owner > 0;
        t.loadToken();
      })
      .catch( () => {
        t.loading = false;
      });
  },
  methods: {
    async checkLE() {
      return this.$store.state.contracts.tinyboxes.methods.isTokenLE((this as any).id).call();
    },
    async loadSettings() {
      const t = this as any;
      const settings =  await t.$store.state.contracts.tinyboxes.methods.readSettings(t.id).call();
      t.data.settings = settings;
      t.settings = {
        bkg: settings.bkg === "101" ? 0 : settings.bkg,
        duration: settings.duration,
        transparent: settings.bkg === "101",
        animate: settings.options % 2 === 1,
      };
    },
    async saveSettings() {
      const t = this as any;
      const settings = [
        t.settings.transparent ? 101 : t.settings.bkg,
        t.settings.duration,
        t.settings.animate ? 1 : 0
      ];
      t.settingsTX = {
        from: this.currentAccount,
        to: this.$store.state.tinyboxesAddress,
        data: this.$store.state.contracts.tinyboxes.methods
          .changeSettings(t.id, settings)
          .encodeABI(),
      };
      t.$store.state.web3.eth.sendTransaction(t.settingsTX,
        async (err: any, txHash: string) => {
          const t = this as any;
          if (err) t.overlay = err.code === 4001 ? "" : "error";
          else {
            t.txHash = txHash;
            t.loadSettings();
            // push auto metadata refresh on OpenSea
            const refeshEndpoint  = 'https://api.opensea.io/asset/' + this.$store.state.tinyboxesAddress + '/' + this.id + '/?force_update=true';
            await t.$http.get(refeshEndpoint);
          }
        }
      );
    },
    resetSettings() {
      const t = this as any;
      const settings = t.data.settings;
      t.settings = {
        bkg: settings.bkg === "101" ? 0 : settings.bkg,
        duration: settings.duration,
        transparent: settings.bkg === "101",
        animate: settings.options % 2 === 1,
      };
    },
    formatHash(account: string) {
      return "0x" + account.slice(2, 6) + "...." + account.slice(-4);
    },
    formatTopic(account: string) {
      return "0x" + account.slice(26, 30) + "...." + account.slice(-4);
    },
    formatTopicLong(account: string) {
      return "0x" + account.slice(-40);
    },
    gotoMint() {
      const d = this.data.tokenData;
      const values = { ...this.data.tokenData, id: this.id, seed: Date.now(), m1: d.mirroring % 4, m2: (d.mirroring / 4 % 4), m3: (d.mirroring / 16 % 4) };
      this.$router.push({ path: "/create", query: (this as any).buildQuery(values) });
    },
    buildQuery(v: any) {
      const t = this as any;
      // condense keys and values for shorter URL encoding
      const out: any = {
        i: v.id,
        r: v.seed,
        s: [v.shapes, v.hatching].join("-"), // shapes - count, hatching
        d: [[v.size[0], v.size[1]].join("~"), [v.size[2], v.size[3]].join("~")].join("-"), // dimensions ranges
        p: v.spacing.join("-"), // positioning - spread, grid
        c: v.color.join("-"), // color - hue, saturation, luminosity
        m: [v.m1, v.m2, v.m3].join("-") // mirroring levels
      };
      return out;
    },
    loadToken: async function() {
      const t = this as any;
      const cached = this.$store.state.cachedTokens[t.id];
      if (cached && typeof cached === "object") {
        this.data = cached;
        this.loading = false;
      } else {
        // load all token data
        const creationPromise = t.lookupMinting();
        const animationPromise = this.$store.state.contracts.tinyboxes.methods.tokenArt(this.id, this.settings.bkg, this.settings.duration, 1, '').call();
        const artPromise = this.$store.state.contracts.tinyboxes.methods.tokenArt(this.id, this.settings.bkg, this.settings.duration, 0, '').call();
        const tokenDataPromise = this.$store.state.contracts.tinyboxes.methods.tokenData(this.id).call();
        this.data.creation = await creationPromise;
        this.data.tx = await this.$store.state.web3.eth.getTransaction(this.data.creation.transactionHash);
        this.data.block = await this.$store.state.web3.eth.getBlock(this.data.creation.blockNumber);
        this.data.animation = await animationPromise;
        this.data.art = await artPromise;
        this.data.tokenData = await tokenDataPromise;
        // cache token data and end loading
        this.$store.commit("setToken", this.data);
        this.loading = false;
      }
    },
    lookupMinting: function() {
      return new Promise((resolve, reject) => {
        this.$store.state.web3.eth
          .subscribe("logs", {
            address: this.$store.state.tinyboxesAddress,
            fromBlock: 0,
            topics: [
              "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
              "0x0000000000000000000000000000000000000000000000000000000000000000",
              null,
              "0x" + BigInt(this.id as number).toString(16).padStart(64, "0"),
            ],
          })
          .on("data", resolve)
          .on("error", reject);
      });
    },
  },
  data: () => ({
    loading: true,
    exists: false,
    animate: true,
    settingsPane: false,
    isLE: false,
    formatedID: '',
    max256: 115792089237316195423570985008687907853269984665640564039457584007913129639936n,
    settings: {
      bkg: 0,
      duration: 10,
      transparent: true,
      animate: true,
    },
    owner: "",
    data: {} as any,
    settingsTX: null,
    txHash: null,
  }),
});
